/* Start User signup */
export const validate = (inputs) => {
  const errors = {};
  if (!inputs.first_name) {
    errors.first_name = "Please enter first name";
  }
  if (!inputs.last_name) {
    errors.last_name = "Please enter last name";
  }
  if (!inputs.email) {
    errors.email = "Please enter email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)) {
    errors.email = "Invalid your email";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }
  if (!inputs.password) {
    errors.password = "Please enter password";
  }
  if (!inputs.confirm_password) {
    errors.confirm_password = "Please enter password confirmation";
  } else if (inputs.password !== inputs.confirm_password) {
    errors.confirm_password = "Password & confirm password must be same";
  }
  if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  return errors;
};
/* End User signup */
/* Start business signup */
export const validatebussignup = (inputs) => {
  const errors = {};
  /*if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
    } 
    if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
    }*/
  if (!inputs.business_name) {
    errors.business_name = "Please enter business name";
  }

  if (!inputs.email) {
    errors.email = "Please enter email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)) {
    errors.email = "Invalid your email";
  }

  if (!inputs.password) {
    errors.password = "Please enter password";
  }
  if (!inputs.confirm_password) {
    errors.confirm_password = "Please enter password confirmation";
  } else if (inputs.password !== inputs.confirm_password) {
    errors.confirm_password = "Password & confirm password must be same";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }
  if (!inputs.address) {
    errors.address = "Please enter address";
  }
  /*if (!inputs.latitude) {
    errors.address = "Please enter address";
  }
  if (!inputs.longitude) {
    errors.address = "Please enter address";
  }*/
  if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  if (!inputs.category_id || inputs.category_id.length === 0) {
    errors.category_id = "Please select at least one category";
  }
  /*if (!inputs.website) {
    errors.website = "Please enter business website";
  }*/
  return errors;
};
/* End business signup */
/* Start User login */
export const validatelogin = (inputs) => {
  const errors = {};
  if (!inputs.email) {
    errors.email = "Please enter email";
  }

  //Password Errors
  if (!inputs.password) {
    errors.password = "Please enter password";
  }
  return errors;
};
/* End User login */
/* Start contact */
export const validatecontact = (inputs) => {
  const errors = {};
  if (!inputs.name) {
    errors.name = "Please enter name";
  }
  if (!inputs.email) {
    errors.email = "Please enter email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)) {
    errors.email = "Invalid your email";
  }
  if (!inputs.subject) {
    errors.subject = "Please enter subject";
  }
  if (!inputs.message) {
    errors.message = "Please enter message";
  }
  return errors;
};
/* End contact */
/* Start Location */
export const validatelocation = (inputs) => {
  const errors = {};
  if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  return errors;
};
/* End Location */
/* Start whatsapp */
export const validatewhatsapp = (inputs) => {
  const errors = {};
  if (!inputs.seller_id) {
    errors.seller_id = "Please enter seller id";
  }
  if (!inputs.name) {
    errors.name = "Please select name";
  }
  if (!inputs.contact) {
    errors.contact = "Please select contact";
  }
  if (!inputs.location) {
    errors.location = "Please select district";
  }
  if (!inputs.membership) {
    errors.membership = "Please select membership";
  }
  return errors;
};
/* End whatsapp */
/* Start Profile */
export const validateprofile = (inputs) => {
  const errors = {};
  if (!inputs.first_name) {
    errors.first_name = "Please enter first name";
  }
  if (!inputs.last_name) {
    errors.last_name = "Please enter last name";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }
  return errors;
};
/* End Profile */
/* Start Complete */
export const validatecompleteprofile = (inputs) => {
  const errors = {};
  if (!inputs.first_name) {
    errors.first_name = "Please enter first name";
  }
  if (!inputs.last_name) {
    errors.last_name = "Please enter last name";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }
  if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  return errors;
};
/* End Complete */
/* Start business profile */
export const validatebusinessprofile = (inputs, hoursofoperation, images) => {
  const errors = {};

  // General validations
  /*if (!inputs.first_name) {
    errors.first_name = 'Please enter first name';
  }
  if (!inputs.last_name) {
    errors.last_name = 'Please enter last name';
  }*/
  if (!inputs.business_name) {
    errors.business_name = "Please enter business name";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }
  /*if (!inputs.business_status) {
    errors.business_status = "Please enter business status";
  }*/
  if (!inputs.address) {
    errors.address = "Please enter address";
  }
  /*if (!inputs.business_description) {
    errors.business_description = "Please enter description";
  }*/
  if (!inputs.category_id || inputs.category_id.length === 0) {
    errors.category_id = "Please select at least one category";
  }
  /*if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }*/
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  

  /*if (!inputs.latitude) {
    errors.address = "Please select address";
  }
  if (!inputs.longitude) {
    errors.address = "Please select address";
  }*/

  /*if (images.length < 1) {
    errors.images = "Please upload at least one image";
  }*/

  // Hours of operation validation
  /*hoursofoperation.forEach((item, index) => {
    const hourErrors = {};
    if (item.end_time !== "Closed") {
      if (!item.start_time || item.start_time.trim() === "") {
        hourErrors.start_time = "Please select start time";
      }
    }
    if (item.start_time !== "Closed") {
      if (!item.end_time || item.end_time.trim() === "") {
        hourErrors.end_time = "Please select end time";
      }
    }
    if (Object.keys(hourErrors).length > 0) {
      errors[`hour_${index}`] = hourErrors; // use key instead of raw index
    }
  });*/

  return errors;
};
/* End business profile */
/* Start business complete profile */
export const validatebusinesscompleteprofile = (inputs) => {
  const errors = {};

  
  if (!inputs.business_name) {
    errors.business_name = "Please enter business name";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }
  
  if (!inputs.address) {
    errors.address = "Please enter address";
  }
  
  if (!inputs.category_id || inputs.category_id.length === 0) {
    errors.category_id = "Please select at least one category";
  }
  if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  

  /*if (!inputs.latitude) {
    errors.address = "Please select address";
  }
  if (!inputs.longitude) {
    errors.address = "Please select address";
  }*/

  return errors;
};
/* End business complete profile */
/* Start add business */
export const validatebusiness = (inputs) => {
  const errors = {};

  // General validations
  /*if (!inputs.first_name) {
    errors.first_name = 'Please enter first name';
  }
  if (!inputs.last_name) {
    errors.last_name = 'Please enter last name';
  }*/
  if (!inputs.business_name) {
    errors.business_name = "Please enter business name";
  }
  if (!inputs.email) {
    errors.email = "Please enter email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)) {
    errors.email = "Invalid your email";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }

  if (!inputs.address) {
    errors.address = "Please enter address";
  }

  /*if (!inputs.latitude) {
    errors.address = "Please enter address";
  }

  if (!inputs.longitude) {
    errors.address = "Please enter address";
  }*/

  if (!inputs.category_id || inputs.category_id.length === 0) {
    errors.category_id = "Please select at least one category";
  }
  if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  return errors;
};
/* End add business */
/* Start add product sale */
export const validateproductsale = (inputs, images) => {
  const errors = {};
  if (!inputs.listing_title) {
    errors.listing_title = "Please enter listing title";
  }
  // if (!inputs.description) {
  //   errors.description = 'Please enter description';
  // }
  if (!inputs.original_mrp) {
    errors.original_mrp = "Please enter original mrp";
  }
  if (!inputs.deal_type) {
    errors.deal_type = "Please select your offer";
  } else {
    if (String(inputs.deal_type) === "2") {
      if (!inputs.buy_qty) {
        errors.buy_qty = "Please enter buy qty";
      }
      if (!inputs.get_qty) {
        errors.get_qty = "Please enter get qty";
      }
    } else if (String(inputs.deal_type) === "1") {
      if (!inputs.discount) {
        errors.discount = "Please enter discount";
      }
      if (!inputs.sale_price) {
        errors.sale_price = "Please enter sale price";
      }
    }
  }
  if (!inputs.beat_online_price) {
    errors.beat_online_price = "Please select beat online price";
  }
  /*if (!inputs.online_price) {
      errors.online_price = 'Please enter online price';
    }*/
  /*if (!inputs.online_link) {
      errors.online_link = 'Please enter online link';
    }*/
  if (!inputs.monthly_deal_limite) {
    errors.monthly_deal_limite = "Please enter monthly deal limite";
  }
  if (!inputs.category_id) {
    errors.category_id = "Please enter category";
  }
  if (!inputs.subcategory_id) {
    errors.subcategory_id = "Please enter sub category";
  }
  if (!inputs.deal_start_date) {
    errors.deal_start_date = "Please enter start date";
  }
  /*if (!inputs.deal_end_date) {
      errors.deal_end_date = 'Please enter end date';
    }*/
  /*if(image.preview==='')
      {
        errors.image = 'Please select image';
      }*/
  // if (images.length < 1) {
  //   errors.images = 'Please upload at least one image';
  // }
  return errors;
};
/* End add product sale */
/* Start add store sale */
export const validatestoresale = (inputs, images) => {
  const errors = {};
  if (!inputs.deal_type) {
    errors.deal_type = "Please enter your offer";
  } else {
    if (String(inputs.deal_type) === "4") {
      if (!inputs.amount) {
        errors.amount = "Please enter amount";
      }
    } else if (String(inputs.deal_type) === "3") {
      if (!inputs.discount) {
        errors.discount = "Please enter discount";
      }
    }
  }
  if (!inputs.listing_title) {
    errors.listing_title = "Please enter listing title";
  }
  // if (!inputs.description) {
  //   errors.description = 'Please enter description';
  // }
  if (!inputs.category_id) {
    errors.category_id = "Please enter category";
  }
  if (!inputs.subcategory_id) {
    errors.subcategory_id = "Please enter sub category";
  }
  if (!inputs.deal_start_date) {
    errors.deal_start_date = "Please enter start date";
  }
  /*if (!inputs.deal_end_date) {
      errors.deal_end_date = 'Please enter end date';
    }*/
  if (!inputs.monthly_deal_limite) {
    errors.monthly_deal_limite = "Please enter monthly deal limite";
  }
  // if (images.length < 1) {
  //   errors.images = 'Please upload at least one image';
  // }
  /*if(image.preview==='')
      {
        errors.image = 'Please select image';
      }*/
  return errors;
};
/* End add store sale */
/* Start add free item sale */
export const validatefreeitemsale = (inputs, images) => {
  const errors = {};
  if (!inputs.listing_title) {
    errors.listing_title = "Please enter listing title";
  }

  // if (!inputs.description) {
  //   errors.description = 'Please enter description';
  // }
  if (!inputs.category_id) {
    errors.category_id = "Please enter category";
  }
  if (!inputs.subcategory_id) {
    errors.subcategory_id = "Please enter sub category";
  }
  if (!inputs.deal_start_date) {
    errors.deal_start_date = "Please enter start date";
  }
  /*if (!inputs.deal_end_date) {
      errors.deal_end_date = 'Please enter end date';
    }*/
  if (!inputs.free_item) {
    errors.free_item = "Please enter free item";
  }
  if (!inputs.monthly_deal_limite) {
    errors.monthly_deal_limite = "Please enter monthly deal limite";
  }
  // if (images.length < 1) {
  //   errors.images = 'Please upload at least one image';
  // }
  /*if(image.preview==='')
      {
        errors.image = 'Please select image';
      }*/

  return errors;
};
/* End add free item sale */
/* Start add gallery */
export const validategallery = (inputs, images) => {
  const errors = {};

  if (!inputs.title) {
    errors.title = "Please enter title";
  }
  if (!images || images.length === 0) {
    errors.images = "Please select at least one image";
  }
  return errors;
};
/* End add gallery */
/* Start add local stories */
export const validatelocalstories = (inputs, images) => {
  const errors = {};

  if (!inputs.story_title) {
    errors.story_title = "Please enter story title";
  }
  if (!inputs.question) {
    errors.question = "Please enter Question";
  }
  if (!inputs.article) {
    errors.article = "Please enter article";
  }
  if (!images || images.length === 0) {
    errors.images = "Please select at least one image";
  }
  return errors;
};
/* End add local stories */
/* Start add local question */
export const validatelocalquestion = (inputs, images) => {
  const errors = {};

  if (!inputs.type_your_post) {
    errors.type_your_post = "Please enter type your post";
  }
  if (!images || images.length === 0) {
    errors.images = "Please select at least one image";
  }
  return errors;
};
/* End add local question */
/* Start add local event */
export const validatelocalevent = (inputs, images) => {
  const errors = {};

  if (!inputs.event_title) {
    errors.event_title = "Please enter event title";
  }
  if (!inputs.event_date) {
    errors.event_date = "Please enter event date";
  }
  if (!inputs.from_time) {
    errors.from_time = "Please enter from time";
  }
  if (!inputs.to_time) {
    errors.to_time = "Please enter to time";
  }
  if (!inputs.event_venue) {
    errors.event_venue = "Please enter event venue";
  }
  if (!inputs.event_detail) {
    errors.event_detail = "Please enter event detail";
  }
  if (!inputs.contact_detail) {
    errors.contact_detail = "Please enter contact detail";
  }
  if (!images || images.length === 0) {
    errors.images = "Please select at least one image";
  }
  return errors;
};
/* End add local event */
/* Start add opinion survey */
export const validateopinionsurvey = (inputs, images, option) => {
  const errors = {};

  if (!inputs.question) {
    errors.question = "Please enter question";
  }
  if (!inputs.poll_expiry) {
    errors.poll_expiry = "Please enter poll expiry";
  }

  if (
    !option ||
    option.length === 0 ||
    option.every((input) => input.trim() === "")
  ) {
    errors.option = "Please enter at least one option";
  }
  if (!images || images.length === 0) {
    errors.images = "Please select at least one image";
  }
  return errors;
};
/* End add opinion survey */
/* Start add promotion */
export const validatepromotion = (inputs) => {
  const errors = {};

  if (!inputs.start_date) {
    errors.start_date = "Please enter start date";
  }
  if (!inputs.promote_on) {
    errors.promote_on = "Please enter promote on";
  }
  if (!inputs.number_of_days) {
    errors.number_of_days = "Please enter number of days";
  }
  if (!inputs.coupon_code) {
    errors.coupon_code = "Please enter coupon code";
  }
  return errors;
};
/* End add promotion */
/* Start Forgot Password */
export const validateforgotpassword = (inputs) => {
  const errors = {};

  if (!inputs.email) {
    errors.email = "Please enter email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)) {
    errors.email = "Invalid your email";
  }

  return errors;
};
/* End Forgot Password */
/* Start Forgot password OTP */
export const validateforotp = (inputs) => {
  const errors = {};

  var i = 0;
  inputs.forEach((item, index) => {
    if (item === "") {
      i++;
    }
  });

  if (i > 0) {
    errors.otp = "Please enter your OTP";
  }
  return errors;
};
/* End Forgot password OTP */
/* Start User forgot pass */
export const validatefogpass = (inputs) => {
  const errors = {};
  //Password Errors
  if (!inputs.newPassword) {
    errors.newPassword = "Please enter your password";
  }

  if (!inputs.confirmPassword) {
    errors.confirmPassword = "Please enter Re-enter New Password";
  }

  if (inputs.newPassword !== inputs.confirmPassword) {
    errors.confirmPassword = "Password & Confirm Password does not match.";
  }
  return errors;
};
/* End User forgot pass */
/* Start switch business profile */
export const validateswitchbusinessprofile = (inputs) => {
  const errors = {};

  // General validations
  /*if (!inputs.first_name) {
    errors.first_name = 'Please enter first name';
  }
  if (!inputs.last_name) {
    errors.last_name = 'Please enter last name';
  }*/
  if (!inputs.business_name) {
    errors.business_name = "Please enter business name";
  }
  if (!inputs.email) {
    errors.email = "Please enter email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)) {
    errors.email = "Invalid your email";
  }
  if (!inputs.contact_number) {
    errors.contact_number = "Please enter contact number";
  }

  if (!inputs.address) {
    errors.address = "Please enter address";
  }
  /*if (!inputs.latitude) {
    errors.address = "Please enter address";
  }

  if (!inputs.longitude) {
    errors.address = "Please enter address";
  }*/

  if (!inputs.category_id || inputs.category_id.length === 0) {
    errors.category_id = "Please select at least one category";
  }
  if (!inputs.pincode) {
    errors.pincode = "Please enter pin code";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  return errors;
};
/* End switch business profile */
/* Start Switch Profile */
export const validateswitchprofile = (inputs) => {
  const errors = {};
  if (!inputs.first_name) {
    errors.first_name = "Please enter first name";
  }
  if (!inputs.last_name) {
    errors.last_name = "Please enter last name";
  }
  /*if (!inputs.email) {
      errors.email = 'Please enter email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid your email';
    }

    if (!inputs.contact_number) {
      errors.contact_number = 'Please enter contact number';
    } 
    if (!inputs.pincode) {
      errors.pincode = 'Please enter pin code';
    }
    if (!inputs.state) {
      errors.state = 'Please select state';
    }
    if (!inputs.city) {
      errors.city = 'Please select district';
    }
    if (!inputs.town) {
      errors.town = 'Please select town';
    }*/

  return errors;
};
/* End Switch Profile */
/* Start add store sale */
export const validatelocationsearch = (inputs) => {
  const errors = {};
  
  if (!inputs.pincode) {
    errors.pincode = "Please enter pincode";
  }
  if (!inputs.state) {
    errors.state = "Please select state";
  }
  if (!inputs.city) {
    errors.city = "Please select city";
  }
  if (!inputs.town) {
    errors.town = "Please select locality";
  }
  return errors;
};
/* End add store sale */
